import React, { useState } from "react";
import {
  Notification,
  NotificationGroup,
} from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";

export default function Erorrnotification(props) {
  const [state, setState] = useState(false);
  const checkErrors = ()=>{
    setState(props.errors.length > 0);
    return state;
  }

  return (
    <>
      <NotificationGroup
        style={{
          right: 0,
          bottom: 0,
          alignItems: "flex-start",
          flexWrap: "wrap-reverse",
        }}
      >
        <Fade>
          {( ()=>checkErrors()) && (
            <Notification
              type={{
                style: props.type,
                icon: true,
              }}
              style={{fontSize:"1rem"}}
              closable={props.closeButton}
              onClose={() => {
                setState(false);
                props.onErrorCompletion()
              }}
            >
              <span>{props.errors}</span>
            </Notification>
          )}
        </Fade>
      </NotificationGroup>
    </>
  );
}
